document.addEventListener('DOMContentLoaded', function() {
  console.log('Initializing enhanced color selector with automatic bundling - TiaanPepper - 2025-04-12 01:55:37');
  
  const CUSTOM_COLOR_PRICE = 45.00;
  const CUSTOM_COLOR_VARIANT_ID = 42456682168546; // Verified Custom Color product ID
  const CUSTOM_COLOR_PRODUCT_URL = 'https://fancyfeather.com/products/custom-color?variant=42456682168546';
  
  // Define standard colors and their images
  const COLORS = {
    'Bright Yellow': '#fffd1e',
    'Golden Yellow': '#ffbb26',
    'Vintage Gold': '#c39143',
    'Neon Yellow': '#edff00',
    'Ferrari Red': '#e4002b',
    'Blood Red': '#ec0037',
    'Burgundy': '#47222c',
    'Peach': '#ffbe98',
    'Coral': '#ff664b',
    'Bright Orange': '#fe5000',
    'Old Orange': '#dc4405',
    'Baby Pink': '#ffeaf1',
    'Light Pink': '#feb9dd',
    'Bright Pink': '#fb48c4',
    'Hot Pink': '#ea27c2',
    'Plum': '#72246C',
    'Fuchsia': '#9e007e',
    'Eggshell': '#f8f7f0',
    'Ivory': '#f6f0d2',
    'Beige': '#E4D7C5',
    'Bone': '#c6ac87',
    'Tan': '#A45A2A',
    'Chocolate Brown': '#4e3629',
    'Jade': '#6eceb2',
    'Mint': '#91D6AC',
    'Lime Green': '#97D700',
    'Chartreuse': '#e3f400',
    'Emerald': '#00965e',
    'Kelly Green': '#00b140',
    'Forest Green': '#115740',
    'Teal': '#007377',
    'Turquoise': '#00b5ec',
    'Aqua': '#aadded',
    'Light Blue': '#bed5f1',
    'Royal Blue': '#0064cc',
    'Navy': '#002851',
    'Lilac': '#8b84d7',
    'Violet': '#5c068c',
    'Amethyst': '#4343a0',
    'Dark Purple': '#4d2a68',
    'White': '#ffffff',
    'Silver': '#dde2e3',
    'Gunmetal': '#323c3f',
    'Black': '#040403',
    'Lavender': '#DFC5FE',
    'Rose Pink': '#F7879A',
    'Tiffany Blue': '#0abab5'
  };

  // Add image mappings
  const COLOR_IMAGES = {
    'Vintage Gold': 'https://cdn.shopify.com/s/files/1/1708/1739/files/vintage_gold.png?v=1742157769',
    'Chocolate Brown': 'https://cdn.shopify.com/s/files/1/1708/1739/files/choc_brown.png?v=1742158912',
    'Blood Red': 'https://cdn.shopify.com/s/files/1/1708/1739/files/blood_red.png?v=1742158937',
    'Burgundy': 'https://cdn.shopify.com/s/files/1/1708/1739/files/burgundy.heic?v=1742158973',
    'Hot Pink': 'https://cdn.shopify.com/s/files/1/1708/1739/files/hot_pink.heic?v=1742159018',
    'Ferrari Red': 'https://cdn.shopify.com/s/files/1/1708/1739/files/ferrari_red.heic?v=1742159075',
    'Golden Yellow': 'https://cdn.shopify.com/s/files/1/1708/1739/files/golden_yellow.heic?v=1742159123',
    'Amethyst': 'https://cdn.shopify.com/s/files/1/1708/1739/files/amethyst.heic?v=1743032667',
    'Light Blue': 'https://cdn.shopify.com/s/files/1/1708/1739/files/light_blue.heic?v=1742159400',
    'Jade': 'https://cdn.shopify.com/s/files/1/1708/1739/files/jade.heic?v=1742159438',
    'Plum': 'https://cdn.shopify.com/s/files/1/1708/1739/files/plum.heic?v=1742159509',
    'Bright Orange': 'https://cdn.shopify.com/s/files/1/1708/1739/files/bright_orange.heic?v=1742159540',
    'Silver': 'https://cdn.shopify.com/s/files/1/1708/1739/files/silver.heic?v=1742159584',
    'Tan': 'https://cdn.shopify.com/s/files/1/1708/1739/files/tan.heic?v=1742159661',
    'Peach': 'https://cdn.shopify.com/s/files/1/1708/1739/files/peach.heic?v=1742159607',
    'Navy': 'https://cdn.shopify.com/s/files/1/1708/1739/files/navy.heic?v=1742159692',
    'Turquoise': 'https://cdn.shopify.com/s/files/1/1708/1739/files/turquoise.heic?v=1742159760',
    'Dark Purple': 'https://cdn.shopify.com/s/files/1/1708/1739/files/dark_purple.heic?v=1742159962',
    'Beige': 'https://cdn.shopify.com/s/files/1/1708/1739/files/beige.heic?v=1742160031',
    'Forest Green': 'https://cdn.shopify.com/s/files/1/1708/1739/files/forest_green.heic?v=1742160058',
    'Fuchsia': 'https://cdn.shopify.com/s/files/1/1708/1739/files/fuscia.heic?v=1742160102',
    'Eggshell': 'https://cdn.shopify.com/s/files/1/1708/1739/files/eggshell.heic?v=1742160141',
    'Tiffany Blue': 'https://cdn.shopify.com/s/files/1/1708/1739/files/tiffany.heic?v=1742160214',
    'Lavender': 'https://cdn.shopify.com/s/files/1/1708/1739/files/lavender.heic?v=1742160248',
    'Aqua': 'https://cdn.shopify.com/s/files/1/1708/1739/files/aqua.heic?v=1742160287',
    'Baby Pink': 'https://cdn.shopify.com/s/files/1/1708/1739/files/baby_pink.heic?v=1742160323',
    'Bone': 'https://cdn.shopify.com/s/files/1/1708/1739/files/bone.heic?v=1742160362',
    'Teal': 'https://cdn.shopify.com/s/files/1/1708/1739/files/teal.heic?v=1742160389',
    'Chartreuse': 'https://cdn.shopify.com/s/files/1/1708/1739/files/charteuse.heic?v=1742160429',
    'Kelly Green': 'https://cdn.shopify.com/s/files/1/1708/1739/files/kelly_green.heic?v=1742160467',
    'Old Orange': 'https://cdn.shopify.com/s/files/1/1708/1739/files/old_orange.heic?v=1742160499',
    'Bright Yellow': 'https://cdn.shopify.com/s/files/1/1708/1739/files/bright_yellow.heic?v=1742160529',
    'Mint': 'https://cdn.shopify.com/s/files/1/1708/1739/files/mint.heic?v=1742160576',
    'Emerald': 'https://cdn.shopify.com/s/files/1/1708/1739/files/emerald_green.heic?v=1742160612',
    'Coral': 'https://cdn.shopify.com/s/files/1/1708/1739/files/coral.heic?v=1742160646',
    'Light Pink': 'https://cdn.shopify.com/s/files/1/1708/1739/files/light_pink.heic?v=1742160676',
    'Black': 'https://cdn.shopify.com/s/files/1/1708/1739/files/black.heic?v=1742160704',
    'Royal Blue': 'https://cdn.shopify.com/s/files/1/1708/1739/files/royal_blue.heic?v=1742160734',
    'Neon Yellow': 'https://cdn.shopify.com/s/files/1/1708/1739/files/neon_yellow.heic?v=1742160794',
    'Bright Pink': 'https://cdn.shopify.com/s/files/1/1708/1739/files/bright_pink.heic?v=1742160829',
    'Lilac': 'https://cdn.shopify.com/s/files/1/1708/1739/files/lilac.heic?v=1742161167',
    'White': 'https://cdn.shopify.com/s/files/1/1708/1739/files/bleach_white.heic?v=1742161234',
    'Lime Green': 'https://cdn.shopify.com/s/files/1/1708/1739/files/lime_green.heic?v=1742161279',
    'Rose Pink': 'https://cdn.shopify.com/s/files/1/1708/1739/files/rose_pink.heic?v=1742161317',
    'Violet': 'https://cdn.shopify.com/s/files/1/1708/1739/files/violet.heic?v=1742161348',
    'Ivory': 'https://cdn.shopify.com/s/files/1/1708/1739/files/ivory.jpg?v=1742161371',
    'Gunmetal': 'https://cdn.shopify.com/s/files/1/1708/1739/files/gun_metal.jpg?v=1742161393'
  };
  
  // Define element references
  let elements = {
    colorSelector: document.getElementById('cs-custom-color-selector'),
    standardColorsSection: document.getElementById('cs-standard-colors-section'),
    standardColorsDropdown: document.getElementById('cs-standard-colors-dropdown'),
    standardColorsContent: document.getElementById('cs-standard-colors-content'),
    customColorSection: document.getElementById('cs-custom-color-section'),
    colorSwatches: document.getElementById('cs-color-swatches'),
    customColorPicker: document.getElementById('cs-custom-color-picker'),
    customColorText: document.getElementById('cs-custom-color-text'),
    customColorSubheading: document.getElementById('cs-custom-color-subheading'),
    customSelectedPreview: document.getElementById('cs-custom-selected-preview'),
    selectedColorInfo: document.getElementById('cs-selected-color-info'),
    selectedPreview: document.getElementById('cs-selected-preview'),
    selectedColorText: document.getElementById('cs-selected-color-text'),
    selectedColorSubheading: document.getElementById('cs-selected-color-subheading'),
    primaryColorSwatch: document.getElementById('cs-primary-color-swatch'),
    topColorSwatch: document.getElementById('cs-top-color-swatch'),
    middleColorSwatch: document.getElementById('cs-middle-color-swatch'),
    bottomColorSwatch: document.getElementById('cs-bottom-color-swatch'),
    primaryColorValue: document.getElementById('cs-primary-color-value'),
    topColorValue: document.getElementById('cs-top-color-value'),
    middleColorValue: document.getElementById('cs-middle-color-value'),
    bottomColorValue: document.getElementById('cs-bottom-color-value'),
    primaryFeatherInput: document.getElementById('cs-primary-feather-input'),
    topFeatherInput: document.getElementById('cs-top-feather-input'),
    middleFeatherInput: document.getElementById('cs-middle-feather-input'),
    bottomFeatherInput: document.getElementById('cs-bottom-feather-input'),
    selectionModeInput: document.getElementById('cs-selection-mode-input'),
    fourModeInput: document.getElementById('cs-four-mode-input'),
    priceAdjustmentInput: document.getElementById('cs-price-adjustment-input'),
    customizeButton: document.getElementById('cs-customize-button'),
    colorCustomization: document.getElementById('cs-color-customization'),
    errorMessage: document.getElementById('cs-color-error-message'),
    addToCartButton: document.querySelector('button[type="submit"]'),
    addToCartForm: document.querySelector('form[action="/cart/add"]'),
    priceElement: document.querySelector('.price__regular .money')
  };

  // Get selection mode from the data attribute
  const selectionMode = elements.colorSelector ? 
    elements.colorSelector.getAttribute('data-selection-mode') || 'double' : 
    'double';
    
  // Check if four-color mode is enabled - UPDATED to also check if mode is 'four'
  const hasFourColorMode = elements.colorSelector ?
    (elements.colorSelector.getAttribute('data-cs-four') === 'true' || selectionMode === 'four') :
    false;

  // Get position labels from HTML elements - NEW
// Get position labels from HTML elements - UPDATED
const positionLabels = {
  'primary': document.querySelector('[data-position="primary"] .feather-position-text')?.textContent.replace(':', '').trim() || 'Primary Color',
  'top': document.querySelector('[data-position="top"] .feather-position-text')?.textContent.replace(':', '').trim() || 'Top Feather Color', 
  'middle': document.querySelector('[data-position="middle"] .feather-position-text')?.textContent.replace(':', '').trim() || 'Middle Feather Color',
  'bottom': document.querySelector('[data-position="bottom"] .feather-position-text')?.textContent.replace(':', '').trim() || 'Bottom Feather Color'
};

  // Define global color state
  window.colorState = {
    currentSelection: hasFourColorMode ? 'primary' : 'top',
    primaryColor: null,
    topColor: null,
    middleColor: null,
    bottomColor: null,
    customColorCount: 0,
    lastEditedSelection: hasFourColorMode ? 'primary' : 'top',
    hasAttemptedAddToCart: false,
    selectionMode: selectionMode,
    hasFourColorMode: hasFourColorMode,
    positionLabels: positionLabels // Store position labels for reference
  };

  // Get original price
  let originalPrice = elements.priceElement ? 
    parseFloat(elements.priceElement.textContent.replace(/[^0-9.]/g, '')) : 
    0;

  // Hide error message initially
  if (elements.errorMessage) {
    elements.errorMessage.classList.remove('visible');
  }

  // Make sure hidden inputs exist
  function ensureInputsExist() {
    if (!elements.addToCartForm) {
      console.error('No add to cart form found');
      return;
    }
    
    // Primary color input (for four-color mode)
    if (selectionMode === 'four' && !elements.primaryFeatherInput) {
      const primaryInput = document.createElement('input');
      primaryInput.type = 'hidden';
      primaryInput.name = 'properties[Primary Color]';
      primaryInput.id = 'cs-primary-feather-input';
      elements.addToCartForm.appendChild(primaryInput);
      elements.primaryFeatherInput = primaryInput;
    }
    
    if (!elements.topFeatherInput) {
      const topInput = document.createElement('input');
      topInput.type = 'hidden';
      topInput.name = 'properties[Top Feather Color]';
      topInput.id = 'cs-top-feather-input';
      elements.addToCartForm.appendChild(topInput);
      elements.topFeatherInput = topInput;
    }
    
    if (!elements.middleFeatherInput && (selectionMode === 'triple' || selectionMode === 'four')) {
      const middleInput = document.createElement('input');
      middleInput.type = 'hidden';
      middleInput.name = 'properties[Middle Feather Color]';
      middleInput.id = 'cs-middle-feather-input';
      elements.addToCartForm.appendChild(middleInput);
      elements.middleFeatherInput = middleInput;
    }
    
    if (!elements.bottomFeatherInput && (selectionMode === 'double' || selectionMode === 'triple' || selectionMode === 'four')) {
      const bottomInput = document.createElement('input');
      bottomInput.type = 'hidden';
      bottomInput.name = 'properties[Bottom Feather Color]';
      bottomInput.id = 'cs-bottom-feather-input';
      elements.addToCartForm.appendChild(bottomInput);
      elements.bottomFeatherInput = bottomInput;
    }
    
    if (!elements.priceAdjustmentInput) {
      const priceInput = document.createElement('input');
      priceInput.type = 'hidden';
      priceInput.name = 'properties[_Price Adjustment]';
      priceInput.id = 'cs-price-adjustment-input';
      elements.addToCartForm.appendChild(priceInput);
      elements.priceAdjustmentInput = priceInput;
    }
    
    if (!elements.selectionModeInput) {
      const modeInput = document.createElement('input');
      modeInput.type = 'hidden';
      modeInput.name = 'properties[_Selection Mode]';
      modeInput.id = 'cs-selection-mode-input';
      modeInput.value = selectionMode;
      elements.addToCartForm.appendChild(modeInput);
      elements.selectionModeInput = modeInput;
    }
    
    if (!elements.fourModeInput && selectionMode === 'four') {
      const fourModeInput = document.createElement('input');
      fourModeInput.type = 'hidden';
      fourModeInput.name = 'properties[_Four Color Mode]';
      fourModeInput.id = 'cs-four-mode-input';
      fourModeInput.value = 'true';
      elements.addToCartForm.appendChild(fourModeInput);
      elements.fourModeInput = fourModeInput;
    }
  }

  // Ensure inputs exist
  ensureInputsExist();

  // Helper function to get contrast color for text
  function getContrastColor(hexcolor) {
    if (!hexcolor) return '#000000';
    
    const r = parseInt(hexcolor.substring(1, 3), 16);
    const g = parseInt(hexcolor.substring(3, 5), 16);
    const b = parseInt(hexcolor.substring(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    
    return brightness > 150 ? '#000000' : '#ffffff';
  }

  // Update the preview swatch with gradient overlay based on text content
  function updatePreviewSwatch(colorName, colorCode, isCustom = false) {
    const isCustomActive = elements.customColorSection && elements.customColorSection.classList.contains('active');
    
    let currentColor;
    switch (colorState.currentSelection) {
      case 'primary':
        currentColor = colorState.primaryColor;
        break;
      case 'top':
        currentColor = colorState.topColor;
        break;
      case 'middle':
        currentColor = colorState.middleColor;
        break;
      case 'bottom':
        currentColor = colorState.bottomColor;
        break;
    }
    
    const colorImage = COLOR_IMAGES[colorName];
    const displayMode = (currentColor && ((currentColor.isCustom && isCustomActive) || (!currentColor.isCustom && !isCustomActive))) ? 'change' : 'select';
    
    if (isCustomActive && elements.customSelectedPreview) {
      elements.customSelectedPreview.style.backgroundColor = colorCode;
      elements.customSelectedPreview.style.backgroundImage = 'none';
      elements.customSelectedPreview.setAttribute('data-mode', displayMode);
      elements.customSelectedPreview.style.color = getContrastColor(colorCode);
      
      if (elements.customColorText) {
        elements.customColorText.textContent = (currentColor && currentColor.isCustom) ? 'Change Color' : 'Pick Color';
      }
      
      if (elements.customColorSubheading) {
        elements.customColorSubheading.textContent = colorCode;
      }
    } else if (elements.selectedPreview) {
      // FIX: Reset text color to black first
      elements.selectedPreview.style.color = '#000000';
      
      if (colorImage && !isCustom) {
        elements.selectedPreview.style.backgroundImage = `url(${colorImage})`;
        elements.selectedPreview.style.backgroundColor = 'transparent';
        // Set text color to white only if the current position has a color selected
        if (currentColor) {
          elements.selectedPreview.style.color = '#ffffff';
        }
      } else {
        elements.selectedPreview.style.backgroundImage = 'none';
        elements.selectedPreview.style.backgroundColor = colorCode;
        // Set text color to white only if the current position has a color selected
        if (currentColor) {
          elements.selectedPreview.style.color = '#ffffff';
        }
      }
      
      // Set the data mode attribute for CSS to apply gradient conditionally
      elements.selectedPreview.setAttribute('data-mode', displayMode);
      
      if (elements.selectedColorText) {
        elements.selectedColorText.textContent = (currentColor && !currentColor.isCustom) ? 'Change Color' : 'Select Color';
      }
      
      if (elements.selectedColorSubheading) {
        elements.selectedColorSubheading.textContent = colorName ? `${colorName} - ${colorCode}` : '';
      }
    }
  }

  // Show current color in the preview
  function showCurrentColorInPreview(position) {
    let currentColor;
    switch (position) {
      case 'primary':
        currentColor = colorState.primaryColor;
        break;
      case 'top':
        currentColor = colorState.topColor;
        break;
      case 'middle':
        currentColor = colorState.middleColor;
        break;
      case 'bottom':
        currentColor = colorState.bottomColor;
        break;
    }
    
    const isCustomTab = elements.customColorSection && elements.customColorSection.classList.contains('active');
    
    if (currentColor) {
      if (isCustomTab) {
        if (currentColor.isCustom) {
          updatePreviewSwatch('Custom Color', currentColor.code, true);
          if (elements.customColorPicker) {
            elements.customColorPicker.value = currentColor.code;
          }
        } else {
          updatePreviewSwatch(currentColor.name, currentColor.code, false);
          if (elements.customColorPicker) {
            elements.customColorPicker.value = currentColor.code;
          }
        }
      } else {
        if (!currentColor.isCustom) {
          updatePreviewSwatch(currentColor.name, currentColor.code, false);
          
          if (elements.colorSwatches) {
            const swatches = elements.colorSwatches.querySelectorAll('.color-swatch');
            swatches.forEach(swatch => {
              if (swatch.dataset.colorCode === currentColor.code) {
                swatch.classList.add('selected');
              } else {
                swatch.classList.remove('selected');
              }
            });
          }
        } else {
          updatePreviewSwatch('Select Color', currentColor.code, false);
          if (elements.colorSwatches) {
            const swatches = elements.colorSwatches.querySelectorAll('.color-swatch');
            swatches.forEach(swatch => {
              swatch.classList.remove('selected');
            });
          }
        }
      }
    } else {
      if (isCustomTab) {
        updatePreviewSwatch('Pick Color', '#ffffff', true);
        if (elements.customColorPicker) {
          elements.customColorPicker.value = '#ffffff';
        }
      } else {
        updatePreviewSwatch('Select Color', '#ffffff', false);
        if (elements.colorSwatches) {
          const swatches = elements.colorSwatches.querySelectorAll('.color-swatch');
          swatches.forEach(swatch => {
            swatch.classList.remove('selected');
          });
        }
      }
    }
  }

// Update color selection - updated by TiaanPepper - 2025-04-12 23:59:25
function updateColorSelection(colorName, colorCode, isCustom) {
  const currentPosition = colorState.currentSelection;
  colorState.lastEditedSelection = currentPosition;

  const colorObject = {
    name: colorName,
    code: colorCode,
    isCustom: isCustom
  };

  // Update appropriate color based on current selection position
  if (currentPosition === 'primary' && (hasFourColorMode || selectionMode === 'four')) {
    colorState.primaryColor = colorObject;
    
    if (elements.primaryColorSwatch) {
      // Add animation class
      elements.primaryColorSwatch.classList.add('just-selected');
      // Remove animation class after animation completes
      setTimeout(() => {
        elements.primaryColorSwatch.classList.remove('just-selected');
      }, 500);
      
      // Only show color in the small circles, not texture
      elements.primaryColorSwatch.style.backgroundColor = colorCode;
      elements.primaryColorSwatch.style.backgroundImage = 'none';
    }
    
    if (elements.primaryColorValue) {
      elements.primaryColorValue.textContent = isCustom ? `Custom - ${colorCode}` : `${colorName} - ${colorCode}`;
    }
    
    if (elements.primaryFeatherInput) {
      elements.primaryFeatherInput.value = isCustom ? `Custom Color - ${colorCode}` : `${colorName} - ${colorCode}`;
    }
  } else if (currentPosition === 'top') {
    colorState.topColor = colorObject;
    
    if (elements.topColorSwatch) {
      // Add animation class
      elements.topColorSwatch.classList.add('just-selected');
      // Remove animation class after animation completes
      setTimeout(() => {
        elements.topColorSwatch.classList.remove('just-selected');
      }, 500);
      
      // Only show color in the small circles, not texture
      elements.topColorSwatch.style.backgroundColor = colorCode;
      elements.topColorSwatch.style.backgroundImage = 'none';
    }
    
    if (elements.topColorValue) {
      elements.topColorValue.textContent = isCustom ? `Custom - ${colorCode}` : `${colorName} - ${colorCode}`;
    }
    
    if (elements.topFeatherInput) {
      elements.topFeatherInput.value = isCustom ? `Custom Color - ${colorCode}` : `${colorName} - ${colorCode}`;
    }
  } else if (currentPosition === 'middle' && (selectionMode === 'triple' || selectionMode === 'four')) {
    colorState.middleColor = colorObject;
    
    if (elements.middleColorSwatch) {
      // Add animation class
      elements.middleColorSwatch.classList.add('just-selected');
      // Remove animation class after animation completes
      setTimeout(() => {
        elements.middleColorSwatch.classList.remove('just-selected');
      }, 500);
      
      // Only show color in the small circles, not texture
      elements.middleColorSwatch.style.backgroundColor = colorCode;
      elements.middleColorSwatch.style.backgroundImage = 'none';
    }
    
    if (elements.middleColorValue) {
      elements.middleColorValue.textContent = isCustom ? `Custom - ${colorCode}` : `${colorName} - ${colorCode}`;
    }
    
    if (elements.middleFeatherInput) {
      elements.middleFeatherInput.value = isCustom ? `Custom Color - ${colorCode}` : `${colorName} - ${colorCode}`;
    }
  } else if (currentPosition === 'bottom' && (selectionMode === 'double' || selectionMode === 'triple' || selectionMode === 'four')) {
    colorState.bottomColor = colorObject;
    
    if (elements.bottomColorSwatch) {
      // Add animation class
      elements.bottomColorSwatch.classList.add('just-selected');
      // Remove animation class after animation completes
      setTimeout(() => {
        elements.bottomColorSwatch.classList.remove('just-selected');
      }, 500);
      
      // Only show color in the small circles, not texture
      elements.bottomColorSwatch.style.backgroundColor = colorCode;
      elements.bottomColorSwatch.style.backgroundImage = 'none';
    }
    
    if (elements.bottomColorValue) {
      elements.bottomColorValue.textContent = isCustom ? `Custom - ${colorCode}` : `${colorName} - ${colorCode}`;
    }
    
    if (elements.bottomFeatherInput) {
      elements.bottomFeatherInput.value = isCustom ? `Custom Color - ${colorCode}` : `${colorName} - ${colorCode}`;
    }
  }

  updatePreviewSwatch(colorName, colorCode, isCustom);
  updateBundleButton(); 
  
  if (elements.errorMessage) {
    elements.errorMessage.classList.remove('visible');
  }
  
  // Auto-switch to next empty color position
  autoSwitchColorSelection();
}

  // Create custom bundle button
  function createCustomBundleButton() {
    // Check if button already exists
    if (document.getElementById('cs-bundle-button')) return;
    
    // Create the bundle button
    const bundleButton = document.createElement('button');
    bundleButton.id = 'cs-bundle-button';
    bundleButton.type = 'button';
    bundleButton.className = 'cs-bundle-button';
    bundleButton.style.display = 'none'; // Initially hidden
    
    // Add button text
    const buttonText = document.createElement('span');
    buttonText.className = 'bundle-btn-text';
    buttonText.textContent = 'Add to cart with custom color (+$0.00)';
    bundleButton.appendChild(buttonText);
    
    // Add the button after the regular Add to Cart button
    if (elements.addToCartButton && elements.addToCartButton.parentNode) {
      elements.addToCartButton.parentNode.insertAdjacentElement('afterend', bundleButton);
      
      // Add click event listener
      bundleButton.addEventListener('click', function(e) {
        e.preventDefault();
        handleAddToCart();
      });
    }
    
    return bundleButton;
  }

  // Add bundle button styles
  function addBundleButtonStyles() {
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      .cs-bundle-button {
        background-color: #DF89B4;
        color: white;
        border: 1px solid #DF89B4;
        padding: 14px 28px;
        font-size: 16px;
        border-radius: 35px;
        cursor: pointer;
        display: block;
        margin-top: 10px;
        width: 100%;
        transition: all 0.3s ease;
        font-weight: normal;
      }
      
      .cs-bundle-button:hover {
        background-color: #DF89B4;
        border-color: #DF89B4;
      }
      
      .cs-bundle-button.loading {
        opacity: 0.7;
        cursor: not-allowed;
      }
      
      /* Better shadow effect for dropdown swatches */
      .color-swatch {
        box-shadow: 0 2px 5px rgba(0,0,0,0.15),
                    0 0 0 1px rgba(0,0,0,0.08);
        transition: all 0.2s ease;
      }
      
            .color-swatch:hover {        
        transform: scale(1.1);
        box-shadow: 0 4px 8px rgba(0,0,0,0.2),
                    0 0 0 1px rgba(0,0,0,0.1);
      }
      
      .color-swatch.selected {
        box-shadow: 0 3px 7px rgba(0,0,0,0.25),
                    0 0 0 2px #000000;
      }
      
      /* Swatch wrapper and label styles */
      .color-swatch-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 4px;
      }
      
      .color-swatch-label {
        font-size: 9px;
        text-align: center;
        color: #555;
        margin-top: 3px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1.2;
      }
    `;
    document.head.appendChild(styleElement);
  }

  // Update the bundle button only
  function updateBundleButton() {
    let customColorCount = 0;
    
    if (selectionMode === 'four') {
      if (colorState.primaryColor && colorState.primaryColor.isCustom) customColorCount++;
      if (colorState.topColor && colorState.topColor.isCustom) customColorCount++;
      if (colorState.middleColor && colorState.middleColor.isCustom) customColorCount++;
      if (colorState.bottomColor && colorState.bottomColor.isCustom) customColorCount++;
    } else {
      if (colorState.topColor && colorState.topColor.isCustom) customColorCount++;
      if (selectionMode === 'triple' && colorState.middleColor && colorState.middleColor.isCustom) customColorCount++;
      if ((selectionMode === 'double' || selectionMode === 'triple') && 
          colorState.bottomColor && colorState.bottomColor.isCustom) customColorCount++;
    }
    
    colorState.customColorCount = customColorCount;
    const priceAdjustment = customColorCount * CUSTOM_COLOR_PRICE;
    
    if (elements.priceAdjustmentInput) {
      elements.priceAdjustmentInput.value = priceAdjustment > 0 ? priceAdjustment.toFixed(2) : '';
    }
    
    // Update or create the bundle button
    let bundleButton = document.getElementById('cs-bundle-button');
    if (!bundleButton) {
      bundleButton = createCustomBundleButton();
    }
    
    if (bundleButton) {
      if (customColorCount > 0) {
        // Show the bundle button when custom colors are selected
        bundleButton.style.display = 'block';
        const buttonText = bundleButton.querySelector('.bundle-btn-text');
        if (buttonText) {
          const currencySymbol = elements.priceElement ? elements.priceElement.textContent.match(/[\$\£\€]/)?.[0] || '$' : '$';
          buttonText.textContent = `Add with Custom Color (+${currencySymbol}${priceAdjustment.toFixed(2)})`;
        }
      } else {
        // Hide the bundle button when no custom colors are selected
        bundleButton.style.display = 'none';
      }
    }
  }

  // Helper function to auto-switch between color selections
  function autoSwitchColorSelection() {
    // For single mode, nothing to switch
    if (selectionMode === 'single') return;
    
    // For four-color mode
    if (selectionMode === 'four') {
      if (colorState.currentSelection === 'primary' && colorState.primaryColor && !colorState.topColor) {
        colorState.currentSelection = 'top';
        colorState.lastEditedSelection = 'top';
      } else if (colorState.currentSelection === 'top' && colorState.topColor && !colorState.middleColor) {
        colorState.currentSelection = 'middle';
        colorState.lastEditedSelection = 'middle';
      } else if (colorState.currentSelection === 'middle' && colorState.middleColor && !colorState.bottomColor) {
        colorState.currentSelection = 'bottom';
        colorState.lastEditedSelection = 'bottom';
      }
    }
    // For double mode
    else if (selectionMode === 'double') {
      if (colorState.currentSelection === 'top' && colorState.topColor && !colorState.bottomColor) {
        colorState.currentSelection = 'bottom';
        colorState.lastEditedSelection = 'bottom';
        
        // Use data-position attribute to find correct elements - UPDATED
        document.querySelectorAll('.color-summary-item').forEach(item => {
          if (item.dataset.position === 'bottom') {
            item.classList.add('active');
            item.querySelector('.status-indicator').classList.remove('hidden');
          } else {
            item.classList.remove('active');
            item.querySelector('.status-indicator').classList.add('hidden');
          }
        });
        
        showCurrentColorInPreview('bottom');
      }
    }
    
    // For triple mode, we need more complex logic
    else if (selectionMode === 'triple') {
      if (colorState.currentSelection === 'top' && colorState.topColor && !colorState.middleColor) {
        // Move from top to middle
        colorState.currentSelection = 'middle';
        colorState.lastEditedSelection = 'middle';
      } else if (colorState.currentSelection === 'middle' && colorState.middleColor && !colorState.bottomColor) {
        // Move from middle to bottom
        colorState.currentSelection = 'bottom';
        colorState.lastEditedSelection = 'bottom';
      }
    }
    
    // Update UI to show active position - UPDATED to use data-position attribute
    document.querySelectorAll('.color-summary-item').forEach(item => {
      const position = item.dataset.position;
      const isActive = position === colorState.currentSelection;
      
      if (isActive) {
        item.classList.add('active');
        item.querySelector('.status-indicator').classList.remove('hidden');
      } else {
        item.classList.remove('active');
        item.querySelector('.status-indicator').classList.add('hidden');
      }
    });
    
    showCurrentColorInPreview(colorState.currentSelection);
  }

  // Initialize color swatches
  function initializeSwatches() {
    if (!elements.colorSwatches) return;
    
    elements.colorSwatches.innerHTML = '';
    
    Object.entries(COLORS).forEach(([name, code]) => {
      // Create a wrapper for the swatch and label
      const wrapper = document.createElement('div');
      wrapper.className = 'color-swatch-wrapper';
      
      // Create the swatch button
      const swatch = document.createElement('button');
      swatch.type = 'button';
      swatch.className = 'color-swatch';
      
      // Only show the color hex in dropdown swatches, not texture images
      swatch.style.backgroundColor = code;
      swatch.style.backgroundImage = 'none'; // Ensure no texture image is shown
      
      swatch.dataset.colorName = name;
      swatch.dataset.colorCode = code;
      
      // Add the label under the swatch
      const label = document.createElement('span');
      label.className = 'color-swatch-label';
      label.textContent = name;
      
      wrapper.appendChild(swatch);
      wrapper.appendChild(label);
      elements.colorSwatches.appendChild(wrapper);
    });
  }

  // Initialize color swatches
  initializeSwatches();

 // Color swatch selection - updated by TiaanPepper - 2025-04-12 23:59:25
if (elements.colorSwatches) {
  elements.colorSwatches.addEventListener('click', function(e) {
    const target = e.target.closest('.color-swatch');
    if (!target) return;
    
    const colorName = target.dataset.colorName;
    const colorCode = target.dataset.colorCode;
    
    elements.colorSwatches.querySelectorAll('.color-swatch').forEach(swatch => {
      swatch.classList.remove('selected');
    });
    target.classList.add('selected');
    
    updateColorSelection(colorName, colorCode, false);
    
    // Only close dropdown if we're on the last color position that needs to be filled
    const isLastPosition = (
      (selectionMode === 'single') ||
      (selectionMode === 'double' && colorState.currentSelection === 'bottom' && colorState.bottomColor) ||
      (selectionMode === 'triple' && colorState.currentSelection === 'bottom' && colorState.bottomColor) ||
      (selectionMode === 'four' && colorState.currentSelection === 'bottom' && colorState.bottomColor)
    );
    
    if (isLastPosition) {
      if (elements.standardColorsContent) {
        elements.standardColorsContent.classList.remove('show');
      }
      
      if (elements.standardColorsDropdown) {
        elements.standardColorsDropdown.classList.remove('active');
      }
    }
  });
}

  // Dropdown functionality
  if (elements.standardColorsDropdown) {
    elements.standardColorsDropdown.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      this.classList.toggle('active');
      if (elements.standardColorsContent) {
        elements.standardColorsContent.classList.toggle('show');
      }
    });
    
    document.addEventListener('click', function(e) {
      if (!e.target.closest('#cs-standard-colors-section') && elements.standardColorsContent) {
        if (elements.standardColorsDropdown) {
          elements.standardColorsDropdown.classList.remove('active');
        }
        elements.standardColorsContent.classList.remove('show');
      }
    });
  }

  // Tab switching
  document.querySelectorAll('.color-option-tab').forEach(tab => {
    tab.addEventListener('click', function() {
      document.querySelectorAll('.color-option-tab').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      const option = this.dataset.option;
      document.querySelectorAll('.color-selector-section').forEach(s => s.classList.remove('active'));
      
      if (option === 'standard' && elements.standardColorsSection) {
        elements.standardColorsSection.classList.add('active');
      } else if (elements.customColorSection) {
        elements.customColorSection.classList.add('active');
      }
      
      showCurrentColorInPreview(colorState.currentSelection);
    });
  });

// Custom color picker - updated by TiaanPepper - 2025-04-12 23:59:25
if (elements.customColorPicker) {
  elements.customColorPicker.addEventListener('input', function() {
    const colorCode = this.value;
    updateColorSelection('Custom Color', colorCode, true);
    
    // Add animation to current color swatch based on position
    let currentSwatch = null;
    switch (colorState.currentSelection) {
      case 'primary':
        currentSwatch = elements.primaryColorSwatch;
        break;
      case 'top':
        currentSwatch = elements.topColorSwatch;
        break;
      case 'middle':
        currentSwatch = elements.middleColorSwatch;
        break;
      case 'bottom':
        currentSwatch = elements.bottomColorSwatch;
        break;
    }
    
    if (currentSwatch) {
      currentSwatch.classList.add('just-selected');
      setTimeout(() => {
        currentSwatch.classList.remove('just-selected');
      }, 500);
    }
  });
}

  // Make custom color preview clickable
  if (elements.customSelectedPreview && elements.customColorPicker) {
    elements.customSelectedPreview.style.cursor = 'pointer';
    elements.customSelectedPreview.addEventListener('click', function(e) {
      if (e.target !== elements.customColorPicker) {
        elements.customColorPicker.click();
      }
    });
  }

  // Color summary item clicks - UPDATED to use data-position attribute
  document.querySelectorAll('.color-summary-item').forEach(item => {
    item.addEventListener('click', function() {
      const position = this.dataset.position;
      if (!position) return; // Skip if no position attribute
      
      // Skip if trying to select a position not valid for current mode
      if (position === 'primary' && selectionMode !== 'four') return;
      if (position === 'middle' && selectionMode !== 'triple' && selectionMode !== 'four') return;
      if (position === 'bottom' && selectionMode === 'single') return;
      
      colorState.currentSelection = position;
      colorState.lastEditedSelection = position;
      
      document.querySelectorAll('.color-summary-item').forEach(i => {
        i.classList.remove('active');
        i.querySelector('.status-indicator').classList.add('hidden');
      });
      
      this.classList.add('active');
      this.querySelector('.status-indicator').classList.remove('hidden');
      
      // FIX: When switching layers, make sure the text is black initially
      if (elements.selectedPreview) {
        elements.selectedPreview.style.color = '#000000';
      }
      
      showCurrentColorInPreview(position);
    });
  });

  // Helper function to validate color selections
  function validateColorSelection() {
    if (!window.colorState) return false;
    
    if (selectionMode === 'four') {
      return !!window.colorState.primaryColor && !!window.colorState.topColor && 
             !!window.colorState.middleColor && !!window.colorState.bottomColor;
    } else if (selectionMode === 'single') {
      return !!window.colorState.topColor;
    } else if (selectionMode === 'double') {
      return !!window.colorState.topColor && !!window.colorState.bottomColor;
    } else if (selectionMode === 'triple') {
      return !!window.colorState.topColor && !!window.colorState.middleColor && !!window.colorState.bottomColor;
    }
    
    return true; // Default to true for unknown modes
  }

  // Customize button handler
  if (elements.customizeButton) {
    elements.customizeButton.addEventListener('click', function() {
      if (elements.colorCustomization) {
        elements.colorCustomization.classList.toggle('show');
        this.textContent = elements.colorCustomization.classList.contains('show') ? 'Hide Color Options' : 'Customize Colors';
      }
    });
  }

window.handleCustomColorAddToCart = function() {
  console.log('Adding to cart with bundling - TiaanPepper - 2025-04-12 23:43:35');
  
  // Validate based on selection mode
  let isValid = validateColorSelection();
  
  if (!isValid) {
    colorState.hasAttemptedAddToCart = true;
    if (elements.errorMessage) {
      elements.errorMessage.classList.add('visible');
    }
    return false;
  }
  
  // Get variant ID
  const variantInput = document.querySelector('input[name="id"]');
  if (!variantInput || !variantInput.value) {
    console.error('Cannot find variant ID');
    return false;
  }

  // Get quantity
  const quantityInput = document.querySelector('input[name="quantity"]');
  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

  // Count custom colors
  let customCount = 0;
  if (selectionMode === 'four') {
    if (colorState.primaryColor && colorState.primaryColor.isCustom) customCount++;
    if (colorState.topColor && colorState.topColor.isCustom) customCount++;
    if (colorState.middleColor && colorState.middleColor.isCustom) customCount++;
    if (colorState.bottomColor && colorState.bottomColor.isCustom) customCount++;
  } else {
    if (colorState.topColor && colorState.topColor.isCustom) customCount++;
    if (selectionMode === 'triple' && colorState.middleColor && colorState.middleColor.isCustom) customCount++;
    if ((selectionMode === 'double' || selectionMode === 'triple') && 
        colorState.bottomColor && colorState.bottomColor.isCustom) customCount++;
  }
  
  // Update button UI to show loading state
  setButtonLoading(true);
  
  // Also set bundle button to loading state if it exists
  const bundleButton = document.getElementById('cs-bundle-button');
  if (bundleButton) {
    bundleButton.classList.add('loading');
    bundleButton.setAttribute('disabled', 'disabled');
    const btnText = bundleButton.querySelector('.bundle-btn-text');
    if (btnText) {
      btnText.textContent = 'Adding...';
    }
  }
  
  // Create line items array for the cart
  const lineItems = [];
  
  // Get exact position labels from the DOM for cart properties
  const primaryLabel = document.querySelector('[data-position="primary"] .feather-position-text')?.textContent.replace(':', '').trim() || 'Primary Color';
  const topLabel = document.querySelector('[data-position="top"] .feather-position-text')?.textContent.replace(':', '').trim() || 'Top Feather Color';
  const middleLabel = document.querySelector('[data-position="middle"] .feather-position-text')?.textContent.replace(':', '').trim() || 'Middle Feather Color';
  const bottomLabel = document.querySelector('[data-position="bottom"] .feather-position-text')?.textContent.replace(':', '').trim() || 'Bottom Feather Color';
  
  // Add main product with properties
  const mainProductItem = {
    id: Number(variantInput.value),
    quantity: quantity,
    properties: {
      '_Selection Mode': selectionMode,
      '_Four Color Mode': selectionMode === 'four' ? 'true' : 'false'
    }
  };
  
  // Add color properties based on selection mode with exact labels
  if (selectionMode === 'four') {
    if (colorState.primaryColor) {
      mainProductItem.properties[primaryLabel] = colorState.primaryColor.isCustom 
        ? `Custom - ${colorState.primaryColor.code}` 
        : colorState.primaryColor.name;
    }
    
    if (colorState.topColor) {
      mainProductItem.properties[topLabel] = colorState.topColor.isCustom 
        ? `Custom - ${colorState.topColor.code}` 
        : colorState.topColor.name;
    }
    
    if (colorState.middleColor) {
      mainProductItem.properties[middleLabel] = colorState.middleColor.isCustom 
        ? `Custom - ${colorState.middleColor.code}` 
        : colorState.middleColor.name;
    }
    
    if (colorState.bottomColor) {
      mainProductItem.properties[bottomLabel] = colorState.bottomColor.isCustom 
        ? `Custom - ${colorState.bottomColor.code}` 
        : colorState.bottomColor.name;
    }
  } else if (selectionMode === 'single') {
    // For single mode, use just the top label (without "Color" suffix if not present)
    if (colorState.topColor) {
      // For single mode, we want to ensure the label looks right
      const singleLabel = topLabel.endsWith('Color') ? topLabel : `${topLabel} Color`;
      mainProductItem.properties[singleLabel] = colorState.topColor.isCustom 
        ? `Custom - ${colorState.topColor.code}` 
        : colorState.topColor.name;
    }
  } else {
    // For double and triple modes
    if (colorState.topColor) {
      mainProductItem.properties[topLabel] = colorState.topColor.isCustom 
        ? `Custom - ${colorState.topColor.code}` 
        : colorState.topColor.name;
    }
    
    if (selectionMode === 'triple' && colorState.middleColor) {
      mainProductItem.properties[middleLabel] = colorState.middleColor.isCustom 
        ? `Custom - ${colorState.middleColor.code}` 
        : colorState.middleColor.name;
    }
    
    if ((selectionMode === 'double' || selectionMode === 'triple') && colorState.bottomColor) {
      mainProductItem.properties[bottomLabel] = colorState.bottomColor.isCustom 
        ? `Custom - ${colorState.bottomColor.code}` 
        : colorState.bottomColor.name;
    }
  }
  
  // Get order notes if available
  const orderNotesInput = document.getElementById('OrderNotes-section-template-product-product');
  if (orderNotesInput && orderNotesInput.value.trim()) {
    mainProductItem.properties['Order Notes'] = orderNotesInput.value.trim();
  }
  
  // Add price adjustment if custom colors are selected
  if (customCount > 0) {
    const adjustment = customCount * CUSTOM_COLOR_PRICE;
    mainProductItem.properties['_Price Adjustment'] = adjustment.toFixed(2);
  }
  
  // Always add the main product to the cart
  lineItems.push(mainProductItem);
  
  // Only add the custom color product if custom colors are selected
  if (customCount > 0) {
    // Add the custom color product with quantity matching custom color count * product quantity
    lineItems.push({
      id: CUSTOM_COLOR_VARIANT_ID,
      quantity: customCount * quantity,
      properties: {
        'For Product': document.title.trim(),
        'Custom Color Count': customCount,
        '_Parent Item': `${document.title.trim()} (${mainProductItem.id})`,
        '_Custom Color': 'true'
      }
    });
  }
  
  console.log('Adding to cart with items:', lineItems);
  
  // Add items to cart via AJAX
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ items: lineItems })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    console.log('Added to cart successfully with bundling - TiaanPepper - 2025-04-12 23:43:35');
    console.log('Custom Color Count:', customCount);
    
    // Check if any custom colors were selected
    if (customCount > 0) {
      // For custom colors, redirect to cart page and prevent cart drawer
      console.log('Custom color detected - redirecting to cart page');
      
      // Reset button states before redirecting
      setButtonLoading(false);
      if (bundleButton) {
        bundleButton.classList.remove('loading');
        bundleButton.removeAttribute('disabled');
        const btnText = bundleButton.querySelector('.bundle-btn-text');
        if (btnText) {
          const currencySymbol = elements.priceElement ? elements.priceElement.textContent.match(/[\$\£\€]/)?.[0] || '$' : '$';
          const adjustment = customCount * CUSTOM_COLOR_PRICE;
          btnText.textContent = `Add with Custom Color (+${currencySymbol}${adjustment.toFixed(2)})`;
        }
      }
      
      // Use window.location.href for the redirect
      window.location.href = '/cart';
    } else {
      // For standard colors, open cart drawer
      openCartDrawer();
      
      // Reset button states
      setButtonLoading(false);
      if (bundleButton) {
        bundleButton.classList.remove('loading');
        bundleButton.removeAttribute('disabled');
        const btnText = bundleButton.querySelector('.bundle-btn-text');
        if (btnText) {
          const currencySymbol = elements.priceElement ? elements.priceElement.textContent.match(/[\$\£\€]/)?.[0] || '$' : '$';
          const adjustment = customCount * CUSTOM_COLOR_PRICE;
          btnText.textContent = `Add with Custom Color (+${currencySymbol}${adjustment.toFixed(2)})`;
        }
      }
    }
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    alert('There was a problem adding this item to your cart. Please try again.');
    
    // Reset button states
    setButtonLoading(false);
    if (bundleButton) {
      bundleButton.classList.remove('loading');
      bundleButton.removeAttribute('disabled');
      const btnText = bundleButton.querySelector('.bundle-btn-text');
      if (btnText) {
        const currencySymbol = elements.priceElement ? elements.priceElement.textContent.match(/[\$\£\€]/)?.[0] || '$' : '$';
        const adjustment = customCount * CUSTOM_COLOR_PRICE;
        btnText.textContent = `Add with Custom Color (+${currencySymbol}${adjustment.toFixed(2)})`;
      }
    }
  });
  
  return false;
};
  
  // Make the handleAddToCart function available globally
  window.handleAddToCart = window.handleCustomColorAddToCart;
  
  // Helper function to set button loading state
  function setButtonLoading(isLoading) {
    if (elements.addToCartButton) {
      if (isLoading) {
        elements.addToCartButton.classList.add('loading');
        elements.addToCartButton.setAttribute('disabled', 'disabled');
        
        const btnText = elements.addToCartButton.querySelector('.btn-text');
        if (btnText) {
          btnText.textContent = 'Adding...';
        }
      } else {
        elements.addToCartButton.classList.remove('loading');
        elements.addToCartButton.removeAttribute('disabled');
        
        const btnText = elements.addToCartButton.querySelector('.btn-text');
        if (btnText) {
          btnText.textContent = 'Add to cart';
        }
      }
    }
  }
  
  // Cart drawer opening function
  function openCartDrawer() {
    let cartOpened = false;

    // Method 1: Refresh cart drawer section
    fetch('/?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(response => response.text())
      .then(() => {
            // Dispatch common cart refresh events
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:cart:reload'));
        document.dispatchEvent(new CustomEvent('theme:cart:change'));

        // Try to open using theme functions
        tryThemeCartOpeners();
      })
      .catch(() => {
        tryThemeCartOpeners();
      });

    // Method 2: Try theme-specific cart openers
    function tryThemeCartOpeners() {
      // Dawn theme and derivatives
      if (window.theme) {
        if (typeof window.theme.openCartDrawer === 'function') {
          try {
            window.theme.openCartDrawer();
            cartOpened = true;
            return;
          } catch (e) {
            console.warn('Could not open cart with theme.openCartDrawer', e);
          }
        }

        if (window.theme.cart) {
          // Try various cart method names
          ['open', 'openDrawer', 'updateCart', 'toggleDrawer', 'showDrawer'].forEach(method => {
            if (!cartOpened && typeof window.theme.cart[method] === 'function') {
              try {
                window.theme.cart[method]();
                cartOpened = true;
                return;
              } catch (e) {
                console.warn(`Could not open cart with theme.cart.${method}`, e);
              }
            }
          });
        }
      }

      // Global cart object (Shopify Plus, various themes)
      if (!cartOpened && window.cart) {
        ['open', 'openDrawer', 'toggle', 'showDrawer'].forEach(method => {
          if (!cartOpened && typeof window.cart[method] === 'function') {
            try {
              window.cart[method]();
              cartOpened = true;
              return;
            } catch (e) {
              console.warn(`Could not open cart with cart.${method}`, e);
            }
          }
        });
      }

      // Try to click cart button if methods failed
      if (!cartOpened) {
        tryClickCartButton();
      }
    }

    // Method 3: Try to find and click the cart button
    function tryClickCartButton() {
      const cartButtonSelectors = [
        '[data-drawer-trigger="cart"]', 
        '[data-action="open-drawer"][data-drawer-id="cart"]',
        '[data-cart-toggle]',
        '.cart-icon-bubble',
        '.cart-link',
        '#cart-icon-bubble',
        '.js-drawer-open-cart',
        '.cart-count-bubble',
        '[data-cart-drawer-toggle]',
        '.header__icon--cart',
        '.cart-drawer__toggle',
        '.cart__toggle',
        '[data-cart-sidebar-toggle]',
        'a[href="/cart"]'
      ];

      for (const selector of cartButtonSelectors) {
        const buttons = document.querySelectorAll(selector);
        if (buttons.length) {
          try {
            buttons[0].click();
            cartOpened = true;
            return;
          } catch (e) {
            console.warn(`Could not click cart button ${selector}`, e);
          }
        }
      }

      // Dispatch events as last resort
      dispatchCartEvents();
    }

    // Method 4: Dispatch all known cart events
    function dispatchCartEvents() {
      const cartEvents = [
        'cart:refresh',
        'cart:open',
        'cart.requestStarted',
        'cart.requestComplete',
        'theme:cart:open',
        'theme:cart:updated',
        'theme:loading:end',
        'ajaxCart.afterCartLoad',
        'cart_drawer:open',
        'cart.rendered',
        'drawer_cart_open'
      ];

      cartEvents.forEach(eventName => {
        document.dispatchEvent(new CustomEvent(eventName));
      });

      // Check if cart is visibly open after all attempts
      setTimeout(() => {
        const isCartOpen = !!document.querySelector(
          '.cart-drawer.is-open, .cart-drawer--open, .drawer--is-open, .js-cart-drawer-open, .cart-drawer-open'
        );

        if (!isCartOpen) {
          console.log('Could not open cart automatically. Added to cart successfully.');
        }
      }, 500);
    }
  }
  
  // Function to preload the custom color product
  function preloadCustomColorProduct() {
    const preloadFrame = document.createElement('iframe');
    preloadFrame.style.display = 'none';
    preloadFrame.src = CUSTOM_COLOR_PRODUCT_URL;
    document.body.appendChild(preloadFrame);
    
    setTimeout(() => {
      if (preloadFrame && preloadFrame.parentNode) {
        preloadFrame.parentNode.removeChild(preloadFrame);
      }
    }, 2000);
  }

  // Preload custom color product when custom tab is clicked
  document.querySelectorAll('.color-option-tab').forEach(tab => {
    if (tab.dataset.option === 'custom') {
      tab.addEventListener('click', preloadCustomColorProduct);
    }
  });

  // Initialize display with current selection
  showCurrentColorInPreview(colorState.currentSelection);
  
  // Initialize the bundle button and styles
  addBundleButtonStyles();
  createCustomBundleButton();
  
  console.log('Enhanced color selector with multiple selection modes initialized - TiaanPepper - 2025-04-12 01:55:37');
  console.log('Updated with color name labels and improved swatch styling - TiaanPepper - 2025-04-14 00:31:17');
});